<template>
  <div class="lad-votes">
    <el-button
      size="mini"
      type="text"
      :disabled="disabled"
      @click="handleVote('like')"
    >
      <i class="fa fa-thumbs-up" />
      <span>{{ likes }}</span>
    </el-button>

    <el-button
      size="mini"
      type="text"
      :disabled="disabled"
      @click="handleVote('dislike')"
    >
      <i class="fa fa-thumbs-down" />
      <span>{{ dislikes }}</span>
    </el-button>

    <span v-if="!!message">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'LadVotes',
  props: {
    likes: { type: Number, default: 0 },
    dislikes: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    message: { type: String, default: '' },
  },
  methods: {
    handleVote(vote) {
      this.$emit('change', vote)
    },
  },
}
</script>

<style lang="scss">
.lad-votes {
  .el-button--text {
    color: #999;
  }

  .el-button--text:hover,
  .el-button.is-disabled {
    color: #66b1ff;
  }

  i {
    margin-right: 5px;
  }

  & > span {
    margin-left: 5px;
    font-size: 13px;
    color: #999;
  }
}
</style>
